import React, { Component } from "react";
import "./Profile.css";
import Cookie from 'js-cookie';
// import EditableCell from '../components/EditableCell'
import { Spin, Descriptions, Badge, Form, Input, Button, message } from 'antd';



export default class Profile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: Cookie.get("email"),

            user: {},
            visible: false,
            time: "",
        };
    }
    hide = () => {
        this.setState({
            visible: false,
        });
    };

    handleVisibleChange = visible => {
        this.setState({ visible });
    };



    getUserInformation = () => {
        fetch(`/login/getUserInformation`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: Cookie.get("email"),
            }),
        }).then(res => res.json())
            .then(json => {
                if (json.success) {   
                    this.setState({ //set state
                        loading: false, //to disable the loading status
                        user: json.user,
                        time: json.timeCreation,
                        licenseType: json.user.licenseinfo.licenseType, //licensetype
                        // licenseDate: json.licenseDate,
                        organization: json.organization,
                        expireDate: json.expireDate,
                        expire: json.expire
                    });
                }
            });
    }

    componentDidMount() {
        try {
            this.getUserInformation()
        } catch (e) {
            alert(e);
        }
    }

    // Handle password change input
    handlePasswordChange = (e) => {
        this.setState({ newPassword: e.target.value });
    };

    // Submit the new password to the backend
    submitPasswordChange = () => {
        if (!this.state.newPassword) {
            message.error("Password cannot be empty.");
            return;
        }

        fetch(`/login/changePassword`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: this.state.email,
                newPassword: this.state.newPassword
            }),
        })
        .then(res => res.json())
        .then(json => {
            if (json.success) {
                message.success("Password updated successfully!");
                this.setState({ newPassword: "" }); // Clear the password field
                Cookie.remove('isAuthenticated'); //remove cookie
                Cookie.remove('email');
                
                // Redirect to homepage with a hard refresh
                window.location.href = "/login"; // Full page reload to the login page
            } else {
                message.error("Failed to update password.");
            }
        });
    };

    render() {
        return (
            <div className="Profile">
                <Spin size="large" tip="Loading..." spinning={this.state.loading}>
                    <Descriptions title="User Info" layout="vertical" bordered>
                        <Descriptions.Item label="Email address">{this.state.email}</Descriptions.Item>
                        <Descriptions.Item label="Create time">{this.state.time}</Descriptions.Item>
                        <Descriptions.Item label="Status">
                            {this.state.expire ? 
                                <Badge status="error" text="Expired" /> : 
                                <Badge status="success" text="OK" />
                            }
                        </Descriptions.Item>
                        <Descriptions.Item label="License type">{this.state.licenseType}</Descriptions.Item>
                        <Descriptions.Item label="License expire date">{this.state.expireDate}</Descriptions.Item>
                        <Descriptions.Item label="Organization">{this.state.organization}</Descriptions.Item>
                    </Descriptions>

                    {/* Password change section */}
                    <div style={{ marginTop: "20px" }}>
                        <Input.Password
                            placeholder="Enter new password"
                            value={this.state.newPassword}
                            onChange={this.handlePasswordChange}
                            style={{ width: "300px", marginRight: "10px" }}
                        />
                        <Button type="primary" onClick={this.submitPasswordChange}>
                            Change Password
                        </Button>
                    </div>
                </Spin>
            </div>
        );
    }
}
Profile = Form.create({})(Profile); //create form which can access the data
